export const isLoginSelector = state => state.login.isLogin;

export const loginRequestSelector = state => state.login.loginRequest;

export const errorMessageSelector = state => state.login.errorMessage;
